import { render, staticRenderFns } from "./PersonCardInfo.vue?vue&type=template&id=234db7e2&scoped=true&"
import script from "./PersonCardInfo.vue?vue&type=script&lang=js&"
export * from "./PersonCardInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234db7e2",
  null
  
)

export default component.exports